export default __webpack_public_path__ + "static/media/products-tom-barrett-unsplash.80215e43.jpg";